var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.1875,9 C17.6362314,9 18,9.44771525 18,10 C18,10.5522847 17.6362314,11 17.1875,11 L5.8125,11 C5.36376864,11 5,10.5522847 5,10 C5,9.44771525 5.36376864,9 5.8125,9 L17.1875,9 Z M17.2,4 C17.6418278,4 18,4.44771525 18,5 C18,5.55228475 17.6418278,6 17.2,6 L2.8,6 C2.3581722,6 2,5.55228475 2,5 C2,4.44771525 2.3581722,4 2.8,4 L17.2,4 Z M17.2,14 C17.6418278,14 18,14.4477153 18,15 C18,15.5522847 17.6418278,16 17.2,16 L2.8,16 C2.3581722,16 2,15.5522847 2,15 C2,14.4477153 2.3581722,14 2.8,14 L17.2,14 Z",
    id: "path-1-hamburger"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.799944196
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFP-Imagery",
    transform: "translate(-172.000000, -384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/20px/Hamburger-Menu",
    transform: "translate(170.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-hamburger",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-hamburger",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-hamburger"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1-hamburger"
  }), /*#__PURE__*/React.createElement("g", {
    id: "COLOR/Pink",
    mask: "url(#mask-2-hamburger)",
    fill: "#FF5C6A"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -2.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/HamburgerMenu.e42ea20564eaf9e08c390f24251196ab.svg";
export { ForwardRef as ReactComponent };